import type { RootState } from 'src/reducers/root';

import { selectFlags } from './select-flags';

export const shouldExposeNewEmbedModal = (state: RootState) =>
  !!selectFlags(state)['expose-next-embed-modal'];
